module.exports = __webpack_public_path__ + "img/aws.d5158931.svg";